import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerAnagraficaInTdocResultComponent} from './worker-anagrafica-in-tdoc-result';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.worker-anagrafica-in-tdoc-result', {
            url: '/worker-anagrafica-in-tdoc-result',
            ncyBreadcrumb: {
                label: 'Anagrafica in tDoc',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Anagrafica in tDoc'
            },
            'views': {
                'homeContent': {
                    template: '<worker-anagrafica-in-tdoc-result flex="100"></worker-anagrafica-in-tdoc-result>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const WorkerAnagraficaInTdocModule: string = ng
    .module('worker-anagrafica-in-tdoc-result', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('workerAnagraficaInTdocResult', WorkerAnagraficaInTdocResultComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/anagrafica-in-tdoc/worker-anagrafica-in-tdoc-result/worker-anagrafica-in-tdoc.module.ts